// extracted by mini-css-extract-plugin
export default {"licenseContainer":"licensePage_licenseContainer__MYE2b","title":"licensePage_title__cJ2tn","workRightManual_countRows":"licensePage_workRightManual_countRows__ym3w2"};